import Header from "../../Common/Header";
import Login from "../../Components/Login";
const LoginPage = () => {
  return (
    <>
      <div className="bg-primary max-md:h-auto h-auto text-white">
        <Header />
        <Login />
      </div>
    </>
  );
};

export default LoginPage;
